// A instalação que começou no painel da plataforma (Nuvemshop, Tray). A loja
// autoriza lá, o callback guarda o id no navegador (orren-agents,
// modules/nuvemshop-instalacao.js e modules/tray-instalacao.js) e manda a
// pessoa entrar na conta; é aqui, com a sessão e a loja resolvidas, que o
// vínculo termina. Sem isto a autorização expirava sem ninguém perceber: era o
// painel antigo que fazia esse resgate.
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { ErroDaApi } from '../../shared/api/cliente';
import { ehSuporte, useLoja } from '../../shared/estado/loja';
import { avisar } from '../../shared/ui/avisos';
import { chaveDasIntegracoes, vincularInstalacaoDaNuvemshop, vincularInstalacaoDaTray } from './api';

export const CHAVE_DA_INSTALACAO = 'borainbox_nuvemshop_pendente';
export const CHAVE_DA_INSTALACAO_TRAY = 'borainbox_tray_pendente';

const FONTES = [
  { chave: CHAVE_DA_INSTALACAO, nome: 'Nuvemshop', vincular: vincularInstalacaoDaNuvemshop },
  { chave: CHAVE_DA_INSTALACAO_TRAY, nome: 'Tray', vincular: vincularInstalacaoDaTray },
];

const ler = (chave: string) => { try { return localStorage.getItem(chave); } catch { return null; } };
const esquecer = (chave: string) => { try { localStorage.removeItem(chave); } catch { /* modo anônimo */ } };

export function InstalacaoPendente() {
  const tenantId = useLoja((s) => s.tenantId);
  const suporte = useLoja((s) => ehSuporte(s.papel));
  const consultas = useQueryClient();
  const tentou = useRef(false);

  useEffect(() => {
    // O id pendente é do NAVEGADOR, não da loja: no modo suporte ele ligaria a
    // loja de quem está no computador à loja do cliente que está aberta.
    // Nem tenta, nem esquece — fica pra quando ele voltar à própria loja.
    if (suporte || !tenantId || tentou.current) return;
    const pendentes = FONTES.map((f) => ({ ...f, id: ler(f.chave) })).filter((f) => f.id);
    if (!pendentes.length) return;
    tentou.current = true;
    for (const p of pendentes) {
      p.vincular(p.id as string)
        .then((r) => {
          esquecer(p.chave);
          avisar(`${p.nome} conectada! ${r.store?.name ? `"${r.store.name}"` : 'Sua loja'} já está ligada: agora é só importar o catálogo.`);
          void consultas.invalidateQueries({ queryKey: chaveDasIntegracoes(tenantId) });
        })
        .catch((e: unknown) => {
          // Sessão que caiu no meio: o id fica guardado pra próxima entrada.
          if (e instanceof ErroDaApi && e.status === 401) return;
          // Qualquer outra resposta: o servidor já consumiu (ou nunca teve) o id, repetir só daria o mesmo erro.
          esquecer(p.chave);
          avisar((e instanceof Error && e.message) || `Não foi possível concluir a conexão com a ${p.nome}.`, 'erro');
        });
    }
  }, [tenantId, consultas, suporte]);

  return null;
}
